import React, { PureComponent } from 'react';
import Modal from 'react-modal';
import Button from '../Button';
import styles from './DownloadModel.module.css';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';

const customStyles = {
  content: {
    top: '35%',
    left: '50%',
    width: '500px',
    right: 'auto',
    bottom: 'auto',
    border: '1px solid grey',
    padding: '20px',
    borderRadius: 0,
    transform: 'translate(-50%, -50%)',
  },
};

export default class DownloadModel extends PureComponent {
  state = {
    loading: false,
    model: null,
    version: 0,
    assetType: 'high',
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  downloadModel = async ext => {
    this.setState({ loading: true });
    const { exportModel } = this.props;
    const { model, version } = this.state;
    const id = model._id;
    if (version === null || version < 0) {
      this.setState({ loading: false });
      return;
    }
    const asset = model.assets[version];
    const download = asset.download;
    const orignalFile =
      download &&
      download
        .split('filename=')
        .slice(-1)
        .pop();
    const orginalType = /[.]/.exec(orignalFile)
      ? /[^.]+$/.exec(orignalFile)[0]
      : null;
    if (orginalType && orginalType.toLowerCase() === ext) {
      this.downloadContent(orignalFile, download);
      this.setState({ loading: false });
    } else {
      const fileLink = await exportModel(id, ext, version);
      if (!fileLink) {
        this.setState({ loading: false });
        return;
      }
      const filename = fileLink
        .split('filename=')
        .slice(-1)
        .pop();
      this.downloadContent(filename, fileLink);
      this.setState({ loading: false });
    }
  };

  componentDidMount = async () => {
    const { getModel } = this.props;
    const { router } = this.context;
    const id = router.route.location.pathname.split('/')[2];
    const model = await getModel(id);
    this.setState({ model, version: model.assets.length - 1 });
  };

  filterAssetType = (item, assetType) => {
    if (assetType === 'low') return item.assetType === assetType;
    else {
      return !item.assetType || item.assetType === 'high';
    }
  };

  setVersion = data => this.setState({ version: data && data.value });

  downloadContent = (name, link) => {
    const dlink = document.createElement('a');
    dlink.download = name;
    dlink.href = link;
    dlink.click();
  };

  setAssetType = data => {
    this.setState({ assetType: data && data.value });
  };

  render() {
    const { open, closeModal } = this.props;
    const { model, version, loading, assetType } = this.state;
    if (!model) return null;
    return (
      <Modal isOpen={open} style={customStyles}>
        <div className={styles.title}> Download Model </div>
        <div className={styles.closeIcon} onClick={closeModal} />
        <div className={styles.modelSelect}>
          <ReactSelect
            className={styles.select}
            options={[
              { label: 'High-Poly', value: 'high' },
              { label: 'Low Poly', value: 'low' },
            ]}
            onChange={this.setAssetType}
            value={assetType}
          />
          <ReactSelect
            className={styles.select}
            options={model.assets
              .filter(item => this.filterAssetType(item, assetType))
              .map((item, k) => ({
                label: `Version ${k + 1}`,
                value: model.assets.indexOf(item),
              }))}
            onChange={this.setVersion}
            value={version}
          />
        </div>
        <div className={styles.content}>
          <div className={styles.btnContainer}>
            <Button
              text="Download FBX model"
              onClick={e => this.downloadModel('fbx')}
            />
          </div>
          <div className={styles.btnContainer}>
            <Button
              text="Download OBJ model"
              onClick={e => this.downloadModel('obj')}
            />
          </div>
          <div className={styles.btnContainer}>
            <Button
              text="Download glTF model"
              onClick={e => this.downloadModel('gltf')}
            />
          </div>
          <div className={styles.btnContainer}>
            <Button
              text="Download USDZ model"
              onClick={e => this.downloadModel('usdz')}
            />
          </div>
          {loading && <img src="/img/loading.svg" />}
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DownloadModel/index.js